import React from "react";
import "../Header.css";

export default function Header({ type, chnage, close }) {
  const tabs = [
    { id: 1, label: "NSE-FUTURE" },
    { id: 2, label: "MCX-FUTURE" },
    { id: 3, label: "OPTIONS" },
  ];

  return (
    <div className="NavSearchContainer">
      <div className="NavSearch">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => chnage(tab.id)}
            className={`px-4 py-1 border-2 border-[var(--hover)] whitespace-nowrap text-[12px] font-semibold rounded-md transition-all 
        ${
          type === tab.id
            ? "bg-[var(--primary)] text-white shadow-md"
            : "bg-[var(--background)] text-[var(--text)]"
        }`}
            style={{ marginLeft: 20 }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="NavSearchLetf">
        <button onClick={close} className="btnClear">
          CLOSE
        </button>
      </div>
    </div>
  );
}
